<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                addressForm: () => import('../forms/AddressForm'),
                contactForm: () => import('../forms/ContactForm'),
                fields: [
                    { type: 'autocomplete', text: 'Contact', value: 'contactId', rules: [v => !!v || 'Contact is required'], isRequired: true, form: () => import('./ContactForm'), apiMethod: 'Contacts', claim: 'Contacts' },
                    { type: 'autocomplete', text: 'Address', value: 'addressId', rules: [v => !!v || 'Address is required'], isRequired: true, form: () => import('./AddressForm'), apiMethod: 'Addresses', claim: 'Addresses' },
                ],
                apiMethod: 'ContactAddresses',
                formTitle: 'Contact Address',
            }
        },
    };
</script>
